<template>
  <form @submit.prevent="submitForm" :class="$style.container">
    <div :class="$style.logo"><img src="/icons/big-logo.png" alt="" /></div>
    <p :class="$style.submitError" v-if="submitError">{{ submitError }}</p>
    <div :class="$style.form">
      <div :class="$style.input">
        <input
          @focus="resetInputError('username')"
          v-model="username"
          type="text"
          placeholder="Имя пользователя"
        />
        <p v-if="errors.username" :class="$style.error">
          {{ errors.username }}
        </p>
      </div>
      <div :class="$style.input">
        <div :class="$style.password">
          <input
            @focus="resetInputError('password')"
            v-model="password"
            :type="passwordType"
            placeholder="Пароль"
          />
          <div :class="$style.button" @click="changePasswordType()">
            <img src="/icons/eye.svg" alt="" v-if="passwordType === 'text'" />
            <img
              src="/icons/eye-close.svg"
              alt=""
              v-if="passwordType === 'password'"
            />
          </div>
        </div>
        <p v-if="errors.password" :class="$style.error">
          {{ errors.password }}
        </p>
      </div>
    </div>
    <LoginButton :class="$style.button" />
  </form>
</template>

<script>
import LoginButton from "./LoginButton.vue";
export default {
  components: {
    LoginButton,
  },
  data() {
    return {
      username: "",
      password: "",
      passwordType: "password",
      errors: {
        username: null,
        password: null,
      },
      submitError: null,
    };
  },
  methods: {
    changePasswordType() {
      this.passwordType =
        this.passwordType === "password" ? "text" : "password";
    },
    async submitForm() {
      const approve = this.checkForm();
      if (approve) {
        const user = {
          username: this.username,
          password: this.password,
        };
        const error = await this.$store.dispatch("login", user);
        if (!error) {
          this.resetForm();
          this.$router.push("/");
        } else {
          this.submitError = error;
        }
      }
    },
    checkForm() {
      let approve = true;
      if (!this.username) {
        this.errors.username = "Введите имя";
        approve = false;
      }
      if (!this.password) {
        this.errors.password = "Введите пароль";
        approve = false;
      }
      return approve;
    },
    resetInputError(field) {
      this.errors[field] = null;
    },
    resetForm() {
      this.username = "";
      this.password = "";
      this.errors.username = null;
      this.errors.password = null;
      this.submitError = null;
    },
  },
};
</script>

<style lang="scss" module>
.container {
  max-width: 31.25rem;
  width: 100%;
  background-color: $bg-secondary;
  border-radius: 1rem;
  box-shadow: 2px 3px 32px rgba(139, 149, 158, 0.32);
  padding: 5rem;
  @include mobile {
    padding: 5rem 1.5rem;
  }
  .logo {
    margin: 0 0 4rem 0;

    @include ButtonText;
    img {
      width: 100%;
    }
  }
  .submitError {
    margin: 0 0 2rem 0;
    @include Subtitle;
    color: $red-button;
  }
  .form {
    margin: 0 0 4rem 0;

    .input {
      margin: 0 0 1.5rem 0;

      input {
        @include Body2;
        width: 100%;
        height: 3rem;
        padding: 0.85rem 1rem;
        border: none;
        outline: 0;
        border-radius: 0.25rem;
        background-color: $bg-primary;
        &::placeholder {
          color: $t-secondary;
        }
      }
      .password {
        display: flex;
        align-items: center;
        .button {
          cursor: pointer;
          height: 3rem;
          background-color: $bg-primary;
          border-radius: 0 0.25rem 0.25rem 0;
          padding: 0 1rem;
          img {
            position: relative;
            top: 11.5px;
          }
        }
        input {
          border-radius: 0.25rem 0 0 0.25rem;
        }
      }
    }

    .error {
      @include Subtitle;
      font-size: 0.75rem;
      margin: 0.25rem 0 0 0;
      color: $red-button;
    }
    .reset {
      font-size: 0.75rem;
      font-weight: 400;
      text-align: right;
      color: $gray;
      cursor: pointer;
    }
  }
  .button {
    margin: 0 auto;
  }
}
</style>
